import { spaceOrganizationVisibilitySchema } from "./space-meta.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/organization-space-directory.ts
const ISO_DATE_TIME_SCHEMA = z$1.iso.datetime({ offset: true });
const trimmedNonEmptyStringSchema = z$1.string().trim().min(1);
const nullableIsoDateTimeSchema = z$1.union([ISO_DATE_TIME_SCHEMA, z$1.null()]);
const organizationSpaceDirectoryItemSchema = z$1.strictObject({
	spaceId: trimmedNonEmptyStringSchema,
	name: trimmedNonEmptyStringSchema,
	organizationId: trimmedNonEmptyStringSchema,
	visibility: spaceOrganizationVisibilitySchema,
	joined: z$1.boolean(),
	lastJoinedAt: nullableIsoDateTimeSchema,
	spaceCreatedAt: nullableIsoDateTimeSchema,
	spaceUpdatedAt: nullableIsoDateTimeSchema,
	updatedAt: ISO_DATE_TIME_SCHEMA
});
const organizationSpaceDirectoryResponseSchema = z$1.strictObject({
	organizationId: trimmedNonEmptyStringSchema,
	generatedAt: ISO_DATE_TIME_SCHEMA,
	spaces: z$1.array(organizationSpaceDirectoryItemSchema)
});
const organizationSpaceDirectoryWithMemberCountsItemSchema = organizationSpaceDirectoryItemSchema.extend({ activeMemberCount: z$1.number().int().nonnegative().nullable() });
const organizationSpaceDirectoryWithMemberCountsResponseSchema = z$1.strictObject({
	organizationId: trimmedNonEmptyStringSchema,
	generatedAt: ISO_DATE_TIME_SCHEMA,
	spaces: z$1.array(organizationSpaceDirectoryWithMemberCountsItemSchema)
});
//#endregion
export { organizationSpaceDirectoryItemSchema, organizationSpaceDirectoryResponseSchema, organizationSpaceDirectoryWithMemberCountsItemSchema, organizationSpaceDirectoryWithMemberCountsResponseSchema };

//# sourceMappingURL=organization-space-directory.js.map